import { jwtDecode } from 'jwt-decode'

import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'
import User from '@/types/user'

export type GetUserResponse = {
  token: string
}

export async function getUser(credentials: {
  email: string
  password: string
}) {
  const { data } = await usersApi.post<GetUserResponse>(
    apiRoutes.authUser,
    credentials,
    {
      headers: { Authorization: '' },
    },
  )

  const token = data.token
  const user: User = jwtDecode(token)

  return { token, user }
}
